module.exports = __webpack_public_path__ + "assets/images/03081580b1e4f77e0d8af40b6e28cefe.gif";